import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ModalNames } from 'src/app/common/modal.config';
import { Services } from 'src/app/services/api.service';
import { CountriesStore } from 'src/app/services/countries.store';
import { ErrorMessageService } from 'src/app/services/error-message.util';
import { LoginService } from 'src/app/services/login.service';
import { ModalService } from 'src/app/services/modal.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-registration-membership',
  templateUrl: `${environment.pageFolder}/registration-membership.${environment.pageFolder}.component.html`,
  styleUrls: [`${environment.pageFolder}/registration-membership.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule]
})

export class RegistrationMembershipComponent {
  name = new FormControl('');
  http!: HttpClient;
  profileType: any = []
  profileTypeList: any = []
  profileForm!: FormGroup;
  gdprQuestions: any;
  redirectUrl = environment.redirectUrl;
  profileFormRegistration = this.formBuilder.group({
    email: '',
    firstName: '',
    lastName: "",
    address: "",
    houseNo: "",
    city: "",
    postNo: "",
    country: "",
    phoneNo: "",
    gdprQ1: false,
    gdprQ2: false,
    gdprQ3: false
  });
  pinForm = this.formBuilder.group({
    pin: ""
  })
  coutryList: any;
  successMessage: string = "";
  errorMessage: string = "";
  pinErrorMessage: string = "";
  errorAlreadyHasAccountMessage: string = "";
  loader = document.getElementById("loader-container");
  isPinSent: boolean = false;
  userId: any;
  emailErrorMessage: string = "";
  gdprErrorMessage = "";
  private readonly destroyRef = inject(DestroyRef);

  public readonly modalNamesEnum = ModalNames;

  constructor(
    private formBuilder: FormBuilder,
    public Services: Services, 
    private loginService: LoginService,
    private readonly countriesStore: CountriesStore,
    public modalService: ModalService,
    private readonly errorMessageService: ErrorMessageService) {    
      this.countriesStore.fetchCountries().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => {
        this.coutryList = response;
        let firstCountryId = this.coutryList[0].id
        
        setTimeout(() => {        
          this.profileFormRegistration.patchValue({country: firstCountryId})
        }, 100);
      }
    )
  }

  ngOnInit() {
    this.loader!.style.display = "none";
  }

  register() {
    let validationError = this.userFormValidation();

    if(validationError === true) {
      return;
    }

    this.loader!.style.display = "flex";
    
    this.errorMessage = "";
    this.errorAlreadyHasAccountMessage = "";
    let grdpAnswers = "16004721,16004722,";    

    if(this.profileFormRegistration.value.gdprQ3 === true) {
      grdpAnswers = grdpAnswers + "16004733,";
    }

    let countryName:any = document.getElementById("registration-country");
    var countryNameText = countryName.options[countryName.selectedIndex].text;      

    let body = {
      "userData": {
        "email": this.profileFormRegistration.value.email,
        "firstName": this.profileFormRegistration.value.firstName,
        "lastName": this.profileFormRegistration.value.lastName,
        "address": this.profileFormRegistration.value.address,
        "houseNo":this.profileFormRegistration.value.houseNo,
        "city": this.profileFormRegistration.value.city,
        "postNo": this.profileFormRegistration.value.postNo,
        "country": countryNameText,
        "countryId": Number(this.profileFormRegistration.value.country),
        "phoneNo": this.profileFormRegistration.value.phoneNo
      },
      "gdprData": {
        "gdprTextId": 9,
        "gdprAnswers": grdpAnswers
      }
    }    

    let headers:any = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    this.Services.registerUserMember(body, headers).subscribe(response => {
      let res:any = response;
      this.userId = res.data;
      this.loader!.style.display = "none";

      const memberDataFromRegistation = {
        ime: this.profileFormRegistration.value.firstName,
        prezime: this.profileFormRegistration.value.lastName,
        adresa: this.profileFormRegistration.value.address,
        kucni_broj: this.profileFormRegistration.value.houseNo,
        ptt: this.profileFormRegistration.value.postNo,
        mjesto: this.profileFormRegistration.value.city
      }
      const bodyForSessionStorage = JSON.stringify(memberDataFromRegistation);
      sessionStorage.setItem("memberRegisterData", bodyForSessionStorage);
      
      if(res.success === true && res.data === -1) {
        this.errorAlreadyHasAccountMessage = this.errorMessageService.getErrorMessage("alreadyHasAccount");
        this.successMessage = "";
      } else if(res.success === true) {
        this.successMessage = this.errorMessageService.getSuccessMessage('registrationWithPinSuccess');
        this.isPinSent = true;
      } else {
        this.successMessage = "";
        this.errorMessage = this.errorMessageService.getErrorMessage("error");
      }
    })
  }

  checkValue(event:any) {   
    if(event.target.checked) {
      event.target.nextElementSibling.style.backgroundColor = "#012641c4";
    } else {
      event.target.nextElementSibling.style.backgroundColor = "#e6e6e6";
    }
    this.gdprErrorMessage = ""; 
  }

  userFormValidation() {
    let inputs = document.querySelectorAll('[data-name="user-form-registration"]');
    let gdprQuestions = document.querySelectorAll('[data-name="gdpr-question"]');
    let error = false;
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    this.errorMessage = "";
    this.emailErrorMessage = "";
    this.gdprErrorMessage = ""; 
    
    inputs.forEach((item:any) => {    
      if(!item.value) {        
        item.nextElementSibling.style.width = "100%";
        item.nextElementSibling.style.backgroundColor = "#ed0000";
        error = true;
        this.errorMessage = this.errorMessageService.getErrorMessage('allFieldsRequired');
      }

      if(item.id === "email" && !regex.test(item.value)) {
        item.nextElementSibling.style.width = "100%";
        item.nextElementSibling.style.backgroundColor = "#ed0000";
        error = true;

        this.emailErrorMessage = "Neispravan unos email adrese.";
      }
    })

    gdprQuestions.forEach((item:any) => {     
      if(!item.checked && item.id !== "16004733") {
        error = true;
        item.nextElementSibling.style.backgroundColor = "#ed0000";
        this.gdprErrorMessage = this.errorMessageService.getErrorMessage("termsOfSaleRequired");
      }
    })

    return error;
  }

  submitPin() {
    this.pinErrorMessage = "";
    this.loader!.style.display = "flex";
    const pin: any = this.pinForm.value.pin;
    this.loginService.loginWithPin(this.userId, pin).subscribe({
      next: (data) => {
        
        if(data.success === false) {
          this.loader!.style.display = "none";
          if (data.errors[0].code === "loginError_invalid_pin") {
            this.pinErrorMessage = "Neispravan pin."
          } else if (data.errors[0].code === "loginError_expired_pin") {
            this.pinErrorMessage = "Pin je istekao.";
          } else if(data.errors[0].code === "loginError_invalid_user") {
            this.pinErrorMessage =  "Greška. Pokušajte ponovno.";
          }
        } else {
          localStorage.setItem('accessToken' + environment.connId, data.token);
          const token = localStorage.getItem('accessToken' + environment.connId);
          this.loginService.connectionLogin(token);
        } 
      },
      error: (error) => {
        this.loader!.style.display = "none";
        this.pinErrorMessage =  "Greška. Pokušajte ponovno.";
      }
    });
  }
}
